module.exports = __webpack_public_path__ + "img/success.2a682756.svg";